import React, { useEffect } from 'react';
import { CircularProgress, IconButton, makeStyles, Paper, Typography } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import allActions from '../../../actions';
import { StatusDpinDairAPI } from '../../../API/status_dpin_dair';
import { unoTheme } from '../../../assets/styles/unoTheme';
import MyTable from '../../utils/MyTable';
import MyTextField from '../../utils/MyTextField';
import UnoButton from '../../utils/UnoButton';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',

    '& .MuiTableContainer-root': {
      height: 'calc(100vh - 103px) !important',
    }
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
    backgroundColor: unoTheme.hoverTable,
  },
  leftHeader: {

    display: 'flex',
    flexDirection: 'column',
  },
  fundLabel: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1C2228'
  },
  accountLabel: {
    fontSize: '14px',
    color: unoTheme.secondaryColor,
  },
  spacingLeft2: {
    marginLeft: theme.spacing(2)
  },
  green: {
    color: unoTheme.greenMoney,
  },

  addCommentLabel: {
    cursor: "pointer",
    color: unoTheme.defaultTextColor,

    '&:hover': {
      color: unoTheme.mainColor,
    }
  },
  rightDivBackdrop: {
    zIndex: 3,
    backgroundColor: 'white',
    position: 'absolute',
    opacity: 0.85,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    color: unoTheme.mainColor,
    alignItems: 'center',
    justifyContent: 'center',

    '& .progress': {
      color: unoTheme.mainColor
    }
  },
}));


export default function StatusesClientHistoricDpin({ content }) {
  const dispatch = useDispatch();

  const {
    data: { year, clientId }
  } = content;

  const classes = useStyles();

  const startYear = parseInt(year) - 9;

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [historicData, setHistoricData] = useState(null);

  const loadHistoric = async (year, cllientId) => {

    const response = await StatusDpinDairAPI.getStatusesDpinHistoricByClientId(year, cllientId);
    if (response.success) {
      console.log("response.body: ", response.body)
      setHistoricData(response.body.rows);
      setOpenBackdrop(false);
    }

  }

  useEffect(() => {
    if (!year || !clientId) return;
    loadHistoric(year, clientId);
  }, [year, clientId])

  const [openTextCommentArea, setOpenTextCommentArea] = useState();
  const [theComment, setTheComment] = useState("");

  const doSaveComment = async (statusDpinClientId, userId) => {

    const comment = theComment;
    //Verificar tamanho do texto
    if (comment.length > 2048) {
      dispatch(allActions.mainAlertActions.setMainAlert({
        show: true,
        type: "warning",
        message: "O comentário excedeu o limite de caracteres!"
      }))
    } else {
      setOpenBackdrop(true);
      const responseSave = await StatusDpinDairAPI.saveCommentDpin(statusDpinClientId, userId, comment);
      if (responseSave.success) {
        handleComment(null, null);
        await loadHistoric(year, clientId);
      } else {
        setOpenBackdrop(false);
      }
    }
  }

  const handleComment = (statusDpinClientId, comment) => {
    setTheComment(comment);
    setOpenTextCommentArea(statusDpinClientId);
  }

  const getCommentCell = (elementInYear) => {
    const { comment, id, user_id } = elementInYear;
    const isEditting = id === openTextCommentArea;

    if (isEditting) {
      return (
        <div>

          <MyTextField
            value={theComment}
            onChange={(value) => {
              setTheComment(value)
            }}
            multiline={true}
            rows={5}
            rowsMax={5}
            fullWidth />

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

            <UnoButton
              size="verySmall"
              onClick={() => handleComment(null, null)}
              type={'defaultClean'}>
              {"Cancelar"}
            </UnoButton>

            <UnoButton
              size="verySmall"
              onClick={() => doSaveComment(id, user_id)}
              type='primary'>
              {"Salvar"}
            </UnoButton>
          </div>
        </div>
      )
    } else {

      if (comment) {
        return (<div>{comment}</div>)
      } else {
        return (<Typography variant={"body1"} className={classes.addCommentLabel} onClick={() => handleComment(id, comment)}>+ Adicionar comentário</Typography>)
      }

    }

  }

  const renderedHistoric = useMemo(() => {
    if (!historicData) return [];
    const nodes = [];

    const includedYears = [];

    historicData.forEach(element => {

      const { year: rowYear } = element;

      if (!includedYears.includes(rowYear)) {
        includedYears.push(rowYear)
        nodes.push(
          <TableHead>
            <TableRow>
              <TableCell align="left" colSpan={3}>{rowYear}</TableCell>
            </TableRow>
          </TableHead>
        )

        const rowsInYear = historicData.filter(el => el.year === rowYear);

        nodes.push(
          <TableBody>

            {
              rowsInYear.map(elementInYear => (
                <TableRow>
                  <TableCell align="center" >{moment.utc(elementInYear.created_date).format("DD/MM/YYYY")}</TableCell>
                  <TableCell align="left" style={{ color: elementInYear.color }} >{elementInYear.status_name}</TableCell>
                  <TableCell align="left">
                    {getCommentCell(elementInYear)}
                  </TableCell>
                  <TableCell align="left" className="noPaddingCell">
                    <IconButton className={classes.addCommentLabel} style={{ visibility: elementInYear.comment ? "visible" : "hidden" }} onClick={() => handleComment(elementInYear.id, elementInYear.comment)}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            }

          </TableBody>
        )
      }
    });

    return nodes;
  }, [historicData, openTextCommentArea, theComment])

  return (
    <div className={classes.root}>

      <Paper style={{ marginBottom: '4px' }}>
        <div className={classes.header}>
          <div className={classes.leftHeader}>
            <div>
              <Typography
                align={'left'}
                className={classes.fundLabel}>
                Histórico de Status DPIN
              </Typography>
              <Typography
                align={'left'}
                className={classes.accountLabel}>
                <span>Anos:
                  <Typography component="strong" style={{ color: unoTheme.mainColor, marginLeft: "8px" }}>{startYear} a {year}</Typography>
                </span>

              </Typography>
            </div>
          </div>

          <IconButton onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
            <CloseIcon />
          </IconButton>

        </div>
      </Paper>
      <MyTable
        stickyHeader
        nofixed={true}
        size="small">
        <colgroup>
          <col width="12.5%" />
          <col width="37.5%" />
          <col width="45%" />
          <col width="5%" />
        </colgroup>
        {renderedHistoric}
      </MyTable>

      {
        openBackdrop ?
          <div className={classes.rightDivBackdrop}>
            <CircularProgress className={'progress'} />
            <Typography variant={'body1'} style={{ marginTop: '16px' }}>
              Atualizando...
            </Typography>

          </div> : null
      }
    </div>
  )
}
